<template>
  <v-container>
    <module-bar title="REPORTE DE ITEMS" class="d-print-none" />
    <v-card outlined class="d-print-none">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              :loading="loadingItemType"
              v-model="type"
              :items="itemsType"
              item-text="name"
              item-value="id"
              label="Tipo"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="primary" @click="search" :loading="loadignSearch"
          >buscar</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-row v-if="loadignSearch" class="mt-5">
      <v-col cols="12" class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="primary"
          width="2"
          size="60"
        />
      </v-col>
    </v-row>

    <div class="d-none d-print-block">REPORTE DE ITEMS</div>

    <v-card outlined class="mt-10" v-if="items.length > 0">
      <v-card-text>
        ({{ items.length }})
        {{ items.length == 1 ? " item encontrado" : " items encontrados" }}
        <v-list>
          <template v-for="(item, key) in items">
            <v-list-item :key="key" v-if="items">
              <v-list-item-content>
                <v-list-item-title>
                  <b>
                    {{ item.name }}
                  </b>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.type.name }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`key${key}`" v-if="key != items.length - 1" />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";

export default {
  components: { ModuleBar },

  mounted() {
    this.loadTypeItems();
  },

  data() {
    return {
      loadignSearch: false,
      loadingItemType: false,
      type: 0,
      items: [],
      itemsType: [],
    };
  },

  methods: {
    search() {
      this.items = [];
      this.loadignSearch = true;
      setTimeout(() => {
        this.$store.dispatch("reportItemAction", this.type).then((res) => {
          this.items = res;
        });
        this.loadignSearch = false;
      }, 500);
    },

    loadTypeItems() {
      this.loadingTypeItems = true;
      setTimeout(() => {
        this.$store.dispatch("findTypeItemsAction").then((res) => {
          this.itemsType = res;
          this.loadingTypeItems = false;
        });
      }, 500);
    },
  },
};
</script>

<style></style>
